import IAction from "../../types/IAction";
import constants from "../../utils/constants";
import actionTypes from "../actionTypes";
import axios from "axios";
import FileDownload from "js-file-download";
import { errorNotification } from "../../utils/notifications";

const COMISION_CONTACT_CENTER_BASE_URL = "/api/comisiones-contact-center";

export const postCalcularComisiones = (
  formData: FormData,
  periodo: string,
  confirmar: boolean
): IAction => {
  return {
    type: actionTypes.POST_COMISION_CONTACT_CENTER_CALCULAR,
    payload: axios.post(
      `${constants.BASE_URL}${COMISION_CONTACT_CENTER_BASE_URL}/calcular-comisiones`,
      formData,
      {
        withCredentials: true,
        params: { periodo, confirmar }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const getConsultarComisiones = (periodo: string): IAction => {
  return {
    type: actionTypes.GET_COMISION_CONTACT_CENTER_CONSULTAR,
    payload: axios.get(
      `${constants.BASE_URL}${COMISION_CONTACT_CENTER_BASE_URL}/consultar-comisiones`,
      {
        withCredentials: true,
        params: { periodo }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const downloadCsvComisiones = (periodo: string, callback: any) => {
  return axios
    .get(
      `${constants.BASE_URL}${COMISION_CONTACT_CENTER_BASE_URL}/descargar-csv`,
      {
        withCredentials: true,
        params: { periodo },
        responseType: "blob"
      }
    )
    .then(({ data }) => {
      FileDownload(data, `comisiones-contact-center-${periodo}.csv`);
      callback && callback();
    })
    .catch(error => {
      errorNotification("No se pudo descargar el reporte");
      callback && callback(error);
    });
};
